import { render, staticRenderFns } from "./use-referral.vue?vue&type=template&id=28db8d16&scoped=true&"
import script from "./use-referral.vue?vue&type=script&lang=js&"
export * from "./use-referral.vue?vue&type=script&lang=js&"
import style0 from "./use-referral.vue?vue&type=style&index=0&id=28db8d16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28db8d16",
  null
  
)

export default component.exports